'use strict';

module.exports = {
  BASE_URL: 'https://cloud-data.wix-code.com/v1/schemas',
  DEFAULT_ERROR: 'Wix data schemas client error'
};